import axios from 'axios'
import oauth from 'axios-oauth-client'
import tokenProvider from 'axios-token-interceptor'

const baseDomain = 'https://mailinvicta.com'
const baseURL = `${baseDomain}/api`

const getClientCredentials = oauth.client(axios.create({
	baseURL
}), {
	url: '/auth/token',
})



const service = axios.create({
	baseURL
})


service.interceptors.request.use(tokenProvider({
	getToken: () => getClientCredentials().then(response => response.token)
}))

export default service